/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Flex,
  Grid,
  SelectField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { API } from "aws-amplify";
import { getCreditNote } from "../graphql/queries";
import { updateCreditNote } from "../graphql/mutations";
export default function CreditNoteForm(props) {
  const {
    id: idProp,
    creditNote: creditNoteModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    credit_type: "",
    reason: "",
    comments: "",
    at_fault: "",
    approved_by: "",
    requested_at: "",
  };
  const [credit_type, setCredit_type] = React.useState(
    initialValues.credit_type
  );
  const [reason, setReason] = React.useState(initialValues.reason);
  const [comments, setComments] = React.useState(initialValues.comments);
  const [at_fault, setAt_fault] = React.useState(initialValues.at_fault);
  const [approved_by, setApproved_by] = React.useState(
    initialValues.approved_by
  );
  const [requested_at, setRequested_at] = React.useState(
    initialValues.requested_at
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = creditNoteRecord
      ? { ...initialValues, ...creditNoteRecord }
      : initialValues;
    setCredit_type(cleanValues.credit_type);
    setReason(cleanValues.reason);
    setComments(cleanValues.comments);
    setAt_fault(cleanValues.at_fault);
    setApproved_by(cleanValues.approved_by);
    setRequested_at(cleanValues.requested_at);
    setErrors({});
  };
  const [creditNoteRecord, setCreditNoteRecord] =
    React.useState(creditNoteModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await API.graphql({
              query: getCreditNote.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getCreditNote
        : creditNoteModelProp;
      setCreditNoteRecord(record);
    };
    queryData();
  }, [idProp, creditNoteModelProp]);
  React.useEffect(resetStateValues, [creditNoteRecord]);
  const validations = {
    credit_type: [],
    reason: [],
    comments: [],
    at_fault: [],
    approved_by: [],
    requested_at: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          credit_type: credit_type ?? null,
          reason: reason ?? null,
          comments: comments ?? null,
          at_fault: at_fault ?? null,
          approved_by: approved_by ?? null,
          requested_at: requested_at ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await API.graphql({
            query: updateCreditNote.replaceAll("__typename", ""),
            variables: {
              input: {
                id: creditNoteRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "CreditNoteForm")}
      {...rest}
    >
      <SelectField
        label="Credit type"
        placeholder="Please select an option"
        isDisabled={false}
        value={credit_type}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              credit_type: value,
              reason,
              comments,
              at_fault,
              approved_by,
              requested_at,
            };
            const result = onChange(modelFields);
            value = result?.credit_type ?? value;
          }
          if (errors.credit_type?.hasError) {
            runValidationTasks("credit_type", value);
          }
          setCredit_type(value);
        }}
        onBlur={() => runValidationTasks("credit_type", credit_type)}
        errorMessage={errors.credit_type?.errorMessage}
        hasError={errors.credit_type?.hasError}
        {...getOverrideProps(overrides, "credit_type")}
      >
        <option
          children="Credit"
          value="Credit"
          {...getOverrideProps(overrides, "credit_typeoption0")}
        ></option>
        <option
          children="Refund"
          value="Refund"
          {...getOverrideProps(overrides, "credit_typeoption1")}
        ></option>
      </SelectField>
      <SelectField
        label="Reason for Credit Note"
        placeholder="Please select an option"
        isDisabled={false}
        value={reason}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              credit_type,
              reason: value,
              comments,
              at_fault,
              approved_by,
              requested_at,
            };
            const result = onChange(modelFields);
            value = result?.reason ?? value;
          }
          if (errors.reason?.hasError) {
            runValidationTasks("reason", value);
          }
          setReason(value);
        }}
        onBlur={() => runValidationTasks("reason", reason)}
        errorMessage={errors.reason?.errorMessage}
        hasError={errors.reason?.hasError}
        {...getOverrideProps(overrides, "reason")}
      >
        <option
          children="Bad Debt"
          value="Bad Debt"
          {...getOverrideProps(overrides, "reasonoption0")}
        ></option>
        <option
          children="Business Closed"
          value="Business Closed"
          {...getOverrideProps(overrides, "reasonoption1")}
        ></option>
        <option
          children="Cancelled Order"
          value="Cancelled Order"
          {...getOverrideProps(overrides, "reasonoption2")}
        ></option>
        <option
          children="CO - Co-Op"
          value="CO - Co-Op"
          {...getOverrideProps(overrides, "reasonoption3")}
        ></option>
        <option
          children="Damaged"
          value="Damaged"
          {...getOverrideProps(overrides, "reasonoption4")}
        ></option>
        <option
          children="Damaged in transit"
          value="Damaged in transit"
          {...getOverrideProps(overrides, "reasonoption5")}
        ></option>
        <option
          children="Disputed Claim"
          value="Disputed Claim"
          {...getOverrideProps(overrides, "reasonoption6")}
        ></option>
        <option
          children="Duplicate Credit Memo"
          value="Duplicate Credit Memo"
          {...getOverrideProps(overrides, "reasonoption7")}
        ></option>
        <option
          children="Flood Affected"
          value="Flood Affected"
          {...getOverrideProps(overrides, "reasonoption8")}
        ></option>
        <option
          children="Freight Cost"
          value="Freight Cost"
          {...getOverrideProps(overrides, "reasonoption9")}
        ></option>
        <option
          children="Incorrect Margin"
          value="Incorrect Margin"
          {...getOverrideProps(overrides, "reasonoption10")}
        ></option>
        <option
          children="Keying Error"
          value="Keying Error"
          {...getOverrideProps(overrides, "reasonoption11")}
        ></option>
        <option
          children="KFC Swollen Packaging"
          value="KFC Swollen Packaging"
          {...getOverrideProps(overrides, "reasonoption12")}
        ></option>
        <option
          children="Late Arrival of delivery"
          value="Late Arrival of delivery"
          {...getOverrideProps(overrides, "reasonoption13")}
        ></option>
        <option
          children="Missing Delivery"
          value="Missing Delivery"
          {...getOverrideProps(overrides, "reasonoption14")}
        ></option>
        <option
          children="Missing Stock Item"
          value="Missing Stock Item"
          {...getOverrideProps(overrides, "reasonoption15")}
        ></option>
        <option
          children="No access to property"
          value="No access to property"
          {...getOverrideProps(overrides, "reasonoption16")}
        ></option>
        <option
          children="No Expiry Date"
          value="No Expiry Date"
          {...getOverrideProps(overrides, "reasonoption17")}
        ></option>
        <option
          children="No Supplied"
          value="No Supplied"
          {...getOverrideProps(overrides, "reasonoption18")}
        ></option>
        <option
          children="Overpayment"
          value="Overpayment"
          {...getOverrideProps(overrides, "reasonoption19")}
        ></option>
        <option
          children="POD rejected courier error"
          value="POD rejected courier error"
          {...getOverrideProps(overrides, "reasonoption20")}
        ></option>
        <option
          children="POD rejected YF error"
          value="POD rejected YF error"
          {...getOverrideProps(overrides, "reasonoption21")}
        ></option>
        <option
          children="Promotion not applied"
          value="Promotion not applied"
          {...getOverrideProps(overrides, "reasonoption22")}
        ></option>
        <option
          children="QA Issue"
          value="QA Issue"
          {...getOverrideProps(overrides, "reasonoption23")}
        ></option>
        <option
          children="Rebate"
          value="Rebate"
          {...getOverrideProps(overrides, "reasonoption24")}
        ></option>
        <option
          children="Recalled stock"
          value="Recalled stock"
          {...getOverrideProps(overrides, "reasonoption25")}
        ></option>
        <option
          children="Refund"
          value="Refund"
          {...getOverrideProps(overrides, "reasonoption26")}
        ></option>
        <option
          children="Rejected - Fridge breakdown or Power loss"
          value="Rejected - Fridge breakdown or Power loss"
          {...getOverrideProps(overrides, "reasonoption27")}
        ></option>
        <option
          children="Rejected Order"
          value="Rejected Order"
          {...getOverrideProps(overrides, "reasonoption28")}
        ></option>
        <option
          children="Return of Stock"
          value="Return of Stock"
          {...getOverrideProps(overrides, "reasonoption29")}
        ></option>
        <option
          children="Rounding"
          value="Rounding"
          {...getOverrideProps(overrides, "reasonoption30")}
        ></option>
        <option
          children="Samples"
          value="Samples"
          {...getOverrideProps(overrides, "reasonoption31")}
        ></option>
        <option
          children="Scan Sales"
          value="Scan Sales"
          {...getOverrideProps(overrides, "reasonoption32")}
        ></option>
        <option
          children="Short Dated"
          value="Short Dated"
          {...getOverrideProps(overrides, "reasonoption33")}
        ></option>
        <option
          children="Shorts"
          value="Shorts"
          {...getOverrideProps(overrides, "reasonoption34")}
        ></option>
        <option
          children="Swollen Packaging"
          value="Swollen Packaging"
          {...getOverrideProps(overrides, "reasonoption35")}
        ></option>
        <option
          children="Temperature Rejection"
          value="Temperature Rejection"
          {...getOverrideProps(overrides, "reasonoption36")}
        ></option>
        <option
          children="Transfer Debtors"
          value="Transfer Debtors"
          {...getOverrideProps(overrides, "reasonoption37")}
        ></option>
        <option
          children="Unsealed Meals"
          value="Unsealed Meals"
          {...getOverrideProps(overrides, "reasonoption38")}
        ></option>
        <option
          children="Unsold Item"
          value="Unsold Item"
          {...getOverrideProps(overrides, "reasonoption39")}
        ></option>
        <option
          children="Wastage"
          value="Wastage"
          {...getOverrideProps(overrides, "reasonoption40")}
        ></option>
        <option
          children="Wholesale Promotions"
          value="Wholesale Promotions"
          {...getOverrideProps(overrides, "reasonoption41")}
        ></option>
      </SelectField>
      <TextAreaField
        label="Reason Comments"
        isRequired={false}
        isReadOnly={false}
        value={comments}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              credit_type,
              reason,
              comments: value,
              at_fault,
              approved_by,
              requested_at,
            };
            const result = onChange(modelFields);
            value = result?.comments ?? value;
          }
          if (errors.comments?.hasError) {
            runValidationTasks("comments", value);
          }
          setComments(value);
        }}
        onBlur={() => runValidationTasks("comments", comments)}
        errorMessage={errors.comments?.errorMessage}
        hasError={errors.comments?.hasError}
        {...getOverrideProps(overrides, "comments")}
      ></TextAreaField>
      <SelectField
        label="At Fault"
        placeholder="Please select an option"
        isDisabled={false}
        value={at_fault}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              credit_type,
              reason,
              comments,
              at_fault: value,
              approved_by,
              requested_at,
            };
            const result = onChange(modelFields);
            value = result?.at_fault ?? value;
          }
          if (errors.at_fault?.hasError) {
            runValidationTasks("at_fault", value);
          }
          setAt_fault(value);
        }}
        onBlur={() => runValidationTasks("at_fault", at_fault)}
        errorMessage={errors.at_fault?.errorMessage}
        hasError={errors.at_fault?.hasError}
        {...getOverrideProps(overrides, "at_fault")}
      >
        <option
          children="Youfoodz"
          value="Youfoodz"
          {...getOverrideProps(overrides, "at_faultoption0")}
        ></option>
        <option
          children="Be Cool"
          value="Be Cool"
          {...getOverrideProps(overrides, "at_faultoption1")}
        ></option>
        <option
          children="Customer"
          value="Customer"
          {...getOverrideProps(overrides, "at_faultoption2")}
        ></option>
        <option
          children="External Party"
          value="External Party"
          {...getOverrideProps(overrides, "at_faultoption3")}
        ></option>
        <option
          children="N/A - not applicable"
          value="N/A - not applicable"
          {...getOverrideProps(overrides, "at_faultoption4")}
        ></option>
      </SelectField>
      <TextField
        label="Approved by"
        isRequired={false}
        isReadOnly={false}
        value={approved_by}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              credit_type,
              reason,
              comments,
              at_fault,
              approved_by: value,
              requested_at,
            };
            const result = onChange(modelFields);
            value = result?.approved_by ?? value;
          }
          if (errors.approved_by?.hasError) {
            runValidationTasks("approved_by", value);
          }
          setApproved_by(value);
        }}
        onBlur={() => runValidationTasks("approved_by", approved_by)}
        errorMessage={errors.approved_by?.errorMessage}
        hasError={errors.approved_by?.hasError}
        {...getOverrideProps(overrides, "approved_by")}
      ></TextField>
      <TextField
        label="Request Date"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={requested_at}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              credit_type,
              reason,
              comments,
              at_fault,
              approved_by,
              requested_at: value,
            };
            const result = onChange(modelFields);
            value = result?.requested_at ?? value;
          }
          if (errors.requested_at?.hasError) {
            runValidationTasks("requested_at", value);
          }
          setRequested_at(value);
        }}
        onBlur={() => runValidationTasks("requested_at", requested_at)}
        errorMessage={errors.requested_at?.errorMessage}
        hasError={errors.requested_at?.hasError}
        {...getOverrideProps(overrides, "requested_at")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        ></Flex>
      </Flex>
    </Grid>
  );
}
